import { render, staticRenderFns } from "./releaseNotes.vue?vue&type=template&id=ecd11230&scoped=true"
import script from "./releaseNotes.vue?vue&type=script&lang=js"
export * from "./releaseNotes.vue?vue&type=script&lang=js"
import style0 from "./releaseNotes.vue?vue&type=style&index=0&id=ecd11230&prod&lang=scss&scoped=true"
import style1 from "./releaseNotes.vue?vue&type=style&index=1&id=ecd11230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd11230",
  null
  
)

export default component.exports